module.exports = __webpack_public_path__ + "src/assets/models/table_colored2.fbx";